// extracted by mini-css-extract-plugin
module.exports =  {"popover-box":"mFyMaWd","popoverBox":"mFyMaWd"};